export default `<p style="text-align:center">
<strong><span style="font-family: 等线;font-size: 24px">《</span></strong><strong><span style="font-family: 等线;font-size: 24px">优米用户服务协议</span></strong><strong><span style="font-family: 等线;font-size: 21px">声明</span></strong><strong><span style="font-family: 等线;font-size: 21px">》</span></strong>
</p>
<p>
    <span style="font-size: 14px;">尊敬的用户：</span>
</p>
<p>
    <span style="font-size: 14px;">您好！</span>
</p>
<p>
    <span style="font-size: 14px;">欢迎使用优米数字智能软件(深圳)有限公司（以下简称“本公司”）研发的Ai优米数字化透明服务平台（以下简称“平台”）调用您所需要的API。以下所述条款和条件即构成您与本公司就平台API调用事宜所达成的协议（以下简称“本协议”）。</span>
</p>
<p>
    <span style="font-size: 14px;">在您开始调用API之前，请务必充分阅读、理解本协议的全部内容，若有疑问，请向本公司进行咨询。无论您是否认真阅读过本协议的全部内容，当您在Ai优米数字化透明服务平台使用平台服务即表示您已同意受本协议约束。</span>
</p>
<p>
    <span style="font-size: 14px;">您同意本公司有权随时对本协议的内容进行单方面的变更，无需另行单独通知您，只需以消息推送、网页公告等方式予以公布即可，修改后的条款或（和）服务规则于公示时即生效。若您在本协议内容公告变更后继续使用平台服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容调用API。若您不同意修改后的协议内容，请您立即停止调用API。</span>
</p>
<p>
    <span><br/></span>
</p>
<p>
    <span style="font-size: 18px;"><strong><span>第一条 合作内容</span></strong></span>
</p>
<p>
    <span style="font-size: 14px;">1.1 本公司根据本协议的约定向您提供API调用服务，各项API的具体内容及调用方法详见https://www.aiyme.cn/网站（以下简称“本网站”）上的产品介绍和新手指南。</span>
</p>
<p>
    <span style="font-size: 14px;">1.2 未经本公司事先书面同意，您同意不以任何方式转让在本协议项下的任何权利和义务。</span>
</p>
<p>
    <span style="font-size: 14px;">1.3 关于您使用API调用服务的服务费计费标准，您认可只要平台服务接口API调试成功，并反馈比对结果即视为达到使用要求，本公司将与您按购买服务时的约定价格计算并结算本次使用的服务费用。</span>
</p>
<p>
    <strong><span style="font-size: 18px;">第二条 您的权利义务</span></strong>
</p>
<p>
    <span style="font-size: 14px;">2.1 您应具备签订和履行本协议的资质，在调用API时应严格遵守平台的使用规则，严格按照平台的流程实现API的调用。</span>
</p>
<p>
    <span style="font-size: 14px;">2.2 您在调用API时，应严格遵守法律法规的规定，承诺调用API不是为了用于涉赌、涉黄、套现、洗钱、诈骗及其他违反法律规定或违反国家政策、破坏社会公序良俗的经营活动。您向平台提交或上传的相关信息应符合国家法律法规和相关行业规定，不得含有非法信息。</span>
</p>
<p>
    <span style="font-size: 14px;">2.3 您仅得在中国境内（不含港、澳、台）使用认证结果。您用于访问本公司平台的IP地址、服务器（自有或租用）物理地址应当在中国境内（不含港、澳、台）。否则您的平台账户将被立即关停，本公司将解除与您的合作关系，并不予退还相应款项。</span>
</p>
<p>
    <span style="font-size: 14px;">2.4 您应按照本协议的约定使用API服务及服务结果所呈现信息，不得从事任何侵犯个人隐私或商业秘密的活动，不得侵犯他人或公司的合法权益。</span>
</p>
<p>
    <span style="font-size: 14px;">2.5 您选择本协议下的API调用服务仅是为了自己使用，不得以任何方式将本服务部分或全部提供给第三方使用。您应当妥善保管好平台账户信息，并在使用时采取一切合法、必要的手段保证平台和数据服务信息的安全、完整。若因您保管及安全保证不善而导致平台账户信息泄露给您造成损失的，由您自行承担，如因此造成本公司或其他第三方损失的，您还应向实际受损方赔偿相应损失。</span>
</p>
<p>
    <span style="font-size: 14px;">2.6 您保证在调用API服务实施相关查询和认证前，均已经通过合法有效的方式得到被查询信息主体的充分授权【授权包括但不限于：（一）贵司收集因本服务产生的主体信息并向依法成立的第三方机构提供主体信息（包括但不限于信息主体在本服务中产生的行为、授信及不良信息）进行相关信息认证。（二）依法成立的第三方机构查询或核实主体信息；（三）贵司在本服务范围内依法使用主体信息及上述信息认证结果】，并告知信息主体授权所产生的法律后果，该信息主体的授权范围能够满足您的行为和对其信息的合法、合理使用。</span>
</p>
<p>
    <span style="font-size: 14px;">您应当妥善保管被查询信息主体的授权文件，确保在需要查验时能够提供。您获得的相关授权文件当是以书面方式做出，书面方式包括能够确认身份的电子邮件、网页操作和其他通讯工具记录等，视频、录音等授权资料可以作为辅助。若您采用格式条款方式获取信息主体授权的，应按照法律法规的要求对重要条款进行特别强调处理。若需要查验时，您提交的授权文件记录不符、或有伪造或涂改的，本公司有权终止向您提供API调用服务并不退还已向您收取的费用，所造成的一切法律责任均由甲方承担。</span>
</p>
<p>
    <span style="font-size: 14px;">2.7 您不得将通过调用API而获得的数据和信息（包括但不限于乙方的核对结果或信息等）进行任何形式的记录、存储和二次应用。您同意并认可，因数据源原因导致本公司无法依据本协议约定向您反馈验证结果或者导致验证失败的，不属于本公司及平台服务质量问题。</span>
</p>
<p>
    <span style="font-size: 14px;">2.8 您在使用API调用服务时，应向本公司支付API调用服务费。</span>
</p>
<p>
    <span style="font-size: 14px;">2.9 您应指派联系人负责本协议的履行，并设立工作监督邮箱对本协议的执行以及变更情况进行监督。您方变更名称、住所、联系人或电话，应在变更之日起三日内书面通知本公司，否则本公司按上述方式做出的通知即视为已送达。如您方拒收或因您方原因导致邮件无法妥投，视为您方已收到本公司所发出的任何文件。</span>
</p>
<p>
    <span style="font-size: 14px;">2.10 您同意不实施任何可能影响贵我双方合作或者侵犯本公司名誉、市场形象、权益的行为。</span>
</p>
<p>
    <strong><span style="font-size: 18px;">第三条 本公司的权利义务</span></strong>
</p>
<p>
    <span style="font-size: 14px;">3.1 本公司是依据中华人民共和国法律依法成立且有效存续的法人，具备签订和履行本协议之资质。</span>
</p>
<p>
    <span style="font-size: 14px;">3.2 本公司利用平台向您提供API调用服务。本公司将尽力向您提供稳定的API调用平台及相关技术服务，并努力维持WEB界面平台及API接口文档的稳定。</span>
</p>
<p>
    <span style="font-size: 14px;">3.3 本公司将通过新手指南的方式告知您使用平台和调用API的方法，在您无法使用平台时，或API无法被调用时请联系本公司的平台客服。</span>
</p>
<p>
    <span style="font-size: 14px;">3.4 在您发现平台出现使用上的障碍时，请您及时联系本公司的平台客服，本公司将及时处理并使平台恢复到稳定运行状态。</span>
</p>
<p>
    <span style="font-size: 14px;">3.5 您理解并同意平台的品牌和著作权（包括但不限于软件中的图表、图片、动画、视频、音频、音乐、文本以及源代码）归本公司所有，受到相关法律法规的保护。本公司享有平台的品牌、著作权、所有权和知识产权等相应的所有权。在您调用API时，本公司许可您以非专有的形式使用平台。</span>
</p>
<p>
    <span style="font-size: 14px;">3.6 在本公司平台系统进行维护，或需对平台API等服务内容进行修改时，本公司会以公告的方式通知您，请您时刻保持对平台公告的关注以免影响您的使用。若出现非计划性的通信故障等不可预测因素造成的API调用等服务的中断，您同意本公司不承担违约责任。对此，本公司承诺会及时以公告的方式通知您并积极采取措施恢复服务的正常提供。</span>
</p>
<p>
    <span style="font-size: 14px;">3.7 您理解并同意本公司对非因本公司过错造成的数据误差（包括但不限于服务的适用性、错误或疏漏、持续性、准确性、可靠性、完整性、适用于某一特定用途）不承担责任。您同意通过调用API所得到的数据与信息仅作为您判断结果的参考依据项，您自行对运用上述数据与信息所做出的判断及后果承担责任，本公司不对此承担任何责任。</span>
</p>
<p>
    <span style="font-size: 14px;">3.8 您理解并同意本公司有权向您收取API调用费。</span>
</p>
<p>
    <span style="font-size: 14px;">3.9 本公司承诺不实施任何可能影响贵我双方合作或者侵犯您的名誉和权益的行为。</span>
</p>
<p>
    <span style="font-size: 18px;"><strong><span>第四条 保密义务</span></strong></span>
</p>
<p>
    <span style="font-size: 14px;">4.1 您应当对本合同及附件的内容、交易信息、客户的信息、本公司的技术信息以及经营信息等应当保密的信息负有保密义务。保密信息无论以何种形式载于何种载体，无论在披露时是否以口头、图像或以书面方式表明其具有保密性，均属于本合同规定的保密信息。</span>
</p>
<p>
    <span style="font-size: 14px;">4.2 以上保密信息不包括以下内容：</span>
</p>
<p>
    <span style="font-size: 14px;">（1）在本公司传递给您时已被公众掌握的信息或材料；</span>
</p>
<p>
    <span style="font-size: 14px;">（2）在本公司传递给您时已被您通过合法途径依法掌握的信息或材料，且当时您并不负有任何保密义务。</span>
</p>
<p>
    <span style="font-size: 14px;">4.3 经本公司要求或本合同终止后，您应根据本公司的要求返还或销毁所取得的本公司的保密信息及其复印件（或其他任何形式的复制品），并删除计算机中所储存的相关文件或信息。</span>
</p>
<p>
    <span style="font-size: 14px;">4.4 无论您和本公司因何种原因导致停止合作、或合作最终未能完成、或未签订相关合作协议、或依照相关合作协议而解除合作关系的、或合同履行完毕、合同有效期限届满的，您应当立即停止使用保密信息，也不得向本合同以外的第三方披露该等保密信息。</span>
</p>
<p>
    <span style="font-size: 14px;">4.5 您同意并确认，本条约定的保密义务自本协议生效时开始，永久保密，不因本协议的解除、终止、变更而失效。未经本公司事先书面同意的，不得向本协议以外的第三方披露、泄漏保密信息的内容，否则本公司有权依法追究您的全部责任。</span>
</p>
<p>
    <span style="font-size: 18px;"><strong><span>第五条 免责事由</span></strong></span>
</p>
</p>
<p>
    <span style="font-size: 14px;">5.1 您同意并理解不可抗力情形的特殊性，本公司因不可抗力无法向您提供服务的，本公司不承担任何形式的违约责任。在不可抗力的影响消除后，本公司将尽快恢复平台的运营并向您继续提供服务。</span>
</p>
<p>
    <span style="font-size: 14px;">5.2 若本公司因不可抗力不能履行协议的，将在可能的情形下尽可能的履行对您的通知义务，以减轻可能给您造成的损失。</span>
</p>
<p>
    <span style="font-size: 14px;">5.3 本协议所称不可抗力，是指不能预见、不能避免并不能克服的客观情况。不可抗力包括但不限于自然灾害、政府行为、军事管制、战争骚乱、罢工、电力中断、通信中断、服务器瘫痪、黑客入侵、计算机病毒入侵、客户原因、银行原因等。</span>
</p>
<p>
    <span style="font-size: 14px;">5.4 因法律、法规、规章、规定、指引、通知、政策、命令及其他规范性文件或政府行为原因导致本协议不能履行的，适用关于不可抗力的规定。</span>
</p>
<p>
    <span style="font-size: 14px;">5.5 为改善服务质量或数据源方对系统进行调整、升级、扩容等措施而导致服务中断、延时等情况的，本公司不承担相关责任。</span>
</p>
<p>
    <span style="font-size: 18px;"><strong><span>第六条 违约责任</span></strong></span>
</p>
<p>
    <span style="font-size: 14px;">6.1 任何一方违反本协议规定的义务，应对守约方承担违约责任。任何一方在履行本协议的过程中有违反法律法规的行为，应自行承担相应的法律责任。</span>
</p>
<p>
    <span style="font-size: 14px;">6.2 若因您的违约行为，致使本公司无法正常为您提供服务的，不视为本公司违约，您同意本公司不承担违约责任。在您违约的情形下，本公司有权不再向您提供服务，您未使用完的充值金额，本公司也将不再予以返还。若您的违约行为对本公司造成损失的，您还应承担对本公司的损害赔偿责任</span>
</p>
<p>
    <span style="font-size: 14px;">6.3 若因本公司的违约行为，不能为您提供本协议约定的服务，您可向本公司发出书面整改通知。若本公司逾期未进行整改的，您有权终止合作并联系本公司的平台客服要求本公司退还未使用完的充值金额。</span>
</p>
<p>
    <span style="font-size: 18px;"><strong><span>第七条 完整协议</span></strong></span>
</p>
<p>
    <span style="font-size: 14px;">7.1 本协议由本协议条款与平台公示的各项规则组成，相关名词可互相引用参照。</span>
</p>
<p>
    <span style="font-size: 14px;">7.2 您对本协议理解和认同，您即对本协议所有组成部分的内容理解并认同，一旦您使用平台API服务，您和本公司即受本协议所有组成部分的约束。</span>
</p>
<p>
    <span style="font-size: 14px;">7.3 本协议部分内容被有管辖权的法院认定为违法的，并不因此影响其他内容的合法效力。</span>
</p>
<p>
    <span style="font-size: 18px;"><strong><span>第八条 法律适用与管辖</span></strong></span>
</p>
<p>
    <span style="font-size: 14px;">8.1 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。如与本协议有关的某一特定事项缺乏明确法律规定，则应参照通用国际商业惯例和（或）行业惯例。</span>
</p>
<p>
    <span style="font-size: 14px;">8.2 本协议签订地为中华人民共和国贵州省贵安新区。</span>
</p>
<p>
    <span style="font-size: 14px;">8.3 若您和本公司之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交至本协议签订地的人民法院管辖。</span>
</p>
<p>
    <span style="font-size: 14px;">8.4 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</span>
</p>
<p>
    <span style="font-size: 18px;"><strong><span>第九条 其他</span></strong></span>
</p>
<p>
    <span style="font-size: 14px;">9.1 请您再次确认：您使用平台服务即视为您已阅读并同意受本协议的约束。本公司有权在必要时单方修改本合同条款，您可以在平台查阅相关合同条款。本合同条款变更后，如果您继续使用平台API服务，即视为您已接受修改后的合同。如果您不接受修改后的合同，应当停止使用平台服务。</span>
</p>
<p>
    <span style="font-size: 14px;">9.2 如果您对本公司服务的任何部分或本协议的任何条款存有异议，您可以通过停止使用平台API服务并拨打电话400-7166-756向本公司咨询解决。</span>
</p>
<p>
    <span style="font-size: 14px;">9.3 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本合同涵义解释的依据。</span>
</p>
<p>
    <span style="font-size: 14px;">9.4 本协议的最终解释权归优米数字智能软件(深圳)有限公司所有。</span>
</p>
<p>
    <span style="font-size: 14px;">（以下无正文）</span>
</p>
<p>
    <br/>
</p>`